import * as Sentry from '@sentry/browser'
import { Module, ModuleAccessControl } from '../../auth/types'
import { checkSyncPermissions } from '../../shared/utils/syncUtil'
import { getAddressConfig, getAddresses } from './api'
import { clearAddresses, overrideAddresses } from './db/addresses'
import { overrideAddressGroups } from './db/addressGroups'
import { overrideAddressTypes } from './db/addressTypes'

const syncAddresses = async (
  modules: Array<ModuleAccessControl>
): Promise<void> => {
  try {
    if (!checkSyncPermissions(modules, Module.addresses)) {
      return
    }

    const addresses = await getAddresses()
    await overrideAddresses(addresses)
  } catch (error: any) {
    if (error.response?.status === 401) {
      await clearAddresses()
    } else {
      Sentry.captureException(error)
    }
  }
}

const syncAddressConfigs = async (
  modules: Array<ModuleAccessControl>
): Promise<void> => {
  try {
    if (!checkSyncPermissions(modules, Module.addresses)) {
      return
    }

    const addressConfigs = await getAddressConfig()
    await overrideAddressGroups(addressConfigs.addressGroups)
    await overrideAddressTypes(addressConfigs.addressTypes)
  } catch (error: any) {
    if (error.response?.status === 401) {
    }
  }
}

export { syncAddresses, syncAddressConfigs }
